import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { SaveIcon, CalendarIcon } from "../Helper/Icons";
import { LoaderScreen } from "../../components/LoaderScreen";

/**
 * ExtenderFechaModal
 *
 * Props:
 *   open     — bool
 *   onClose  — fn()
 *   folio    — string
 *   onActualizar — fn() — refresca el listado al guardar
 */
export const ExtenderFechaModal = ({
    open,
    onClose,
    folio,
    fecha_fin,
    onActualizar,
}) => {
    const [fechaFin, setFechaFin] = useState("");
    const [loading, setLoading] = useState(false);

    // Cargar fecha actual del registro
    useEffect(() => {
        if (folio && open) {
            const [dia, mes, anio] = fecha_fin.split('/');
            const fechaOriginal = `${anio}-${mes}-${dia}`;

            setFechaFin(fechaOriginal)
        }
    }, [open, folio, fecha_fin]);

    if (!open) return null;

    const handleGuardar = () => {
        if (!fechaFin) {
            Swal.fire("EXTENDER FECHA", "Debe seleccionar una fecha de terminación", "warning");
            return;
        }

        setLoading(true);

        request
            .post("ProgramarInventario/ExtenderFecha", {
                folio,
                fecha_fin: fechaFin,
            })
            .then(async (result) => {
                setLoading(false);
                if (result.resultado === 1) {
                    await Swal.fire("EXTENDER FECHA", result.mensaje, "error");
                } else {
                    await Swal.fire("EXTENDER FECHA", "Fecha actualizada con éxito", "success");
                    onActualizar?.();
                    onClose?.();
                }
            })
            .catch((error) => {
                setLoading(false);
                Swal.fire("EXTENDER FECHA", JSON.stringify(error), "error");
            });
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) onClose?.();
    };

    return (
        <div className="ram-backdrop" onClick={handleBackdropClick}>
            <PlantillaScreen
                titulo={"Extender fecha de terminación"}
                className={"ram-modal efm-modal"}
            >
                <button className="ram-close" onClick={onClose} type="button">
                    X
                </button>

                <LoaderScreen loader={loading} />

                {/* ── Body ── */}
                <div className="ram-body">
                    <div className="ram-field">
                        <div className="ram-field__icon">
                            <CalendarIcon />
                        </div>
                        <div className="ram-field__content">
                            <label className="pa-label--sm">Fecha de terminación</label>
                            <div className="pa-input-wrap">
                                <CalendarIcon />
                                <input
                                    type="date"
                                    value={fechaFin}
                                    onChange={(e) => setFechaFin(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── Footer ── */}
                <div className="ram-footer">
                    <button
                        type="button"
                        className="ram-btn ram-btn--primary"
                        onClick={handleGuardar}
                        disabled={loading || !fechaFin}
                    >
                        {loading ? <span className="ram-btn__spinner" /> : <SaveIcon />}
                        {loading ? "Guardando..." : "Guardar"}
                    </button>
                </div>

            </PlantillaScreen>
        </div>
    );
};

export default ExtenderFechaModal;
